<template>
    <nav :class="[scrolledFromTop ? 'fixed shadow-sm bg-white' : '', 'top-0 z-50 w-full transition-all duration-200']">
        <Container>
            <div class="h-60px relative flex items-center justify-between">
                <div class="lg:px-0 flex items-center justify-between flex-1 px-2">
                    <div class="flex">
                        <div class="flex-shrink-0">
                            <a class="focus:no-underline hover:no-underline" href="javascript:;" onclick="document.documentElement.scrollIntoView({ behavior: 'smooth' });">
                                <div class="w-auto">
                                    <LogoInverse :class="[scrolledFromTop ? 'block' : 'hidden', 'transition-all duration-200']" />
                                    <Logo :class="[scrolledFromTop ? 'hidden' : 'block', 'transition-all duration-200']" />
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="lg:flex lg:items-center hidden">
                        <div class="flex items-center space-x-3">
                            <template v-for="item in navigation">
                                <a href="javascript:;" :onclick="`document.querySelector('#${item.sectionId}').scrollIntoView({ behavior: 'smooth' });`" :class="[scrolledFromTop ? 'hover:text-blue-500 text-gray-body' : 'hover:text-blue-200 text-white', 'focus:no-underline hover:no-underline px-2 py-0.5 font-medium text-sm']">
                                    {{ item.name }}
                                </a>
                            </template>
                        </div>
                        <div :class="[scrolledFromTop ? 'bg-gray-body-lightest bg-opacity-75' : 'bg-blue-300 bg-opacity-50', 'w-px h-6 mx-3']"></div>
                        <div class="flex items-center space-x-3">
                            <a href="/login" :class="[scrolledFromTop ? 'hover:text-blue-500 text-gray-body' : 'hover:text-blue-200 text-white', 'focus:no-underline hover:no-underline px-2 py-0.5 font-medium text-sm']">
                                {{ $t('auth.login') }}
                            </a>
                            <a :class="[scrolledFromTop ? 'border-blue-500 text-blue-500 bg-white hover:bg-blue-500 hover:text-white' : 'border-blue-50 text-blue-500 bg-blue-50 hover:border-blue-100 hover:bg-blue-100 hover:shadow-md', 'focus:no-underline hover:no-underline px-3.5 py-1.5 font-medium border text-sm rounded shadow-sm']"
                                id="sign-up-header-link"
                                href="/sign-up">
                                {{ $t('auth.sign_up') }}
                            </a>
                        </div>
                    </div>
                    <div class="lg:hidden flex">
                        <button class="focus:outline-none relative w-10 h-10" @click="open = !open">
                            <span class="sr-only">Open main menu</span>
                            <div class="left-1/2 top-1/2 absolute block w-5 transform -translate-x-1/2 -translate-y-1/2">
                                <span aria-hidden="true" :class="[scrolledFromTop ? 'bg-blue-500' : 'bg-blue-50', open ? 'rotate-45' : '-translate-y-1.5', 'block absolute h-0.5 w-5 transform transition duration-500 ease-in-out']"></span>
                                <span aria-hidden="true" :class="[scrolledFromTop ? 'bg-blue-500' : 'bg-blue-50', open ? 'opacity-0' : '', 'block absolute h-0.5 w-5 transform transition duration-500 ease-in-out']"></span>
                                <span aria-hidden="true" :class="[scrolledFromTop ? 'bg-blue-500' : 'bg-blue-50', open ? '-rotate-45' : 'translate-y-1.5', 'block absolute h-0.5 w-5 transform transition duration-500 ease-in-out']"></span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </Container>
        <div :class="[!scrolledFromTop && open ? 'border-b border-blue-300' : '', open ? 'block pb-3' : 'hidden', 'lg:hidden']" style="min-height: 200px;">
            <Container>
                <div class="flex flex-col space-y-3">
                    <template v-for="item in navigation">
                        <a href="javascript:;" :onclick="`document.querySelector('#${item.sectionId}').scrollIntoView({ behavior: 'smooth' });`" :class="[scrolledFromTop ? 'hover:text-blue-500 text-gray-body' : 'hover:text-blue-200 text-white', 'focus:no-underline hover:no-underline px-2 py-0.5 font-medium text-sm']">
                            {{ item.name }}
                        </a>
                    </template>
                    <a href="/login" :class="[scrolledFromTop ? 'hover:text-blue-500 text-gray-body' : 'hover:text-blue-200 text-white', 'focus:no-underline hover:no-underline px-2 py-0.5 font-medium text-sm']">
                        {{ $t('auth.login') }}
                    </a>
                    <a href="/sign-up" :class="[scrolledFromTop ? 'hover:text-blue-500 text-gray-body' : 'hover:text-blue-200 text-white', 'focus:no-underline hover:no-underline px-2 py-0.5 font-medium text-sm']">
                        {{ $t('auth.sign_up') }}
                    </a>
                </div>
            </Container>
        </div>
    </nav>
</template>

<script>
import Container from '../../../../shared/container.vue';
import Logo from '../../../../shared/logo.vue';
import LogoInverse from '../../../../shared/logo-inverse.vue';

export default {
    components: {
        Container,
        Logo,
        LogoInverse,
    },

    props: {
        scrolledFromTop: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            open: false,
        };
    },

    computed: {
        navigation() {
            const navigation = [
                {
                    name: this.$t('budgets_landing_page.features_and_benefits'),
                    sectionId: 'features',
                },
                {
                    name: this.$t('budgets_landing_page.our_customers'),
                    sectionId: 'clients',
                },
                {
                    name: this.$t('budgets_landing_page.pricing'),
                    sectionId: 'pricing',
                },
                {
                    name: this.$t('budgets_landing_page.faq'),
                    sectionId: 'faq',
                },
            ];

            return navigation;
        },
    },
};
</script>
